import Actions from '../../odata/actions';

const actions = new Actions('division', 'divisions');

export default actions;
